import http from "../http-common";

class MenuService {
  getmenus() {
    return http.get(`/api/menus`);
  }
  getmenu(id) {
    return http.get(`/api/menus/`+id);
  }
  updatemenu(id, data) {
    return http.put(`/api/menus/${id}`, data);
  }
  updateorder(id, data) {
    return http.put(`/api/menus/updateorder/${id}`, data);
  }
}

export default new MenuService();